import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'custom-circle-progress-bar',
  templateUrl: './custom-circle-progress-bar.component.html',
  styleUrls: ['./custom-circle-progress-bar.component.scss'],
})
export class CustomCircleProgressBarComponent implements OnInit {
  @Input() value: number = 0; // Progress value between 0 and 100
  radius = 60;
  circumference = 2 * Math.PI * this.radius;
  offset = 0;

  ngOnInit(): void {
    this.offset = this.circumference - (this.value / 100) * this.circumference;
  }
}
